import { render, staticRenderFns } from "./International.vue?vue&type=template&id=50d4ac0e&scoped=true"
import script from "./International.vue?vue&type=script&lang=js"
export * from "./International.vue?vue&type=script&lang=js"
import style0 from "./International.vue?vue&type=style&index=0&id=50d4ac0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4ac0e",
  null
  
)

export default component.exports